import React from "react";
import { TextField, TextFieldProps } from "formik-mui";
import { useField, useFormikContext } from "formik";
import * as yup from "yup";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export const RoutingNumberField = Object.assign(
  ({
    name = "routingNumber",
    id = "routing-number",
    label = "Routing Number",
    placeholder = "Routing Number",
    required = true,
    fullWidth = true,
    ...rest
  }: RoutingNumberFieldProps) => {
    const form = useFormikContext();
    const [field, meta, { setValue }] = useField(name);

    const handleChange = React.useCallback(
      (event) => {
        const onlyNums = event.target.value.substr(0, 9).replace(/[^0-9]/g, "");
        setValue(onlyNums);
      },
      [setValue],
    );

    return (
      <Box>
        <Typography variant="body3">{label}</Typography>
        <TextField
          InputLabelProps={{ shrink: false }}
          {...rest}
          {...{ id, placeholder, required, fullWidth }}
          label=""
          meta={meta}
          form={form}
          field={{
            ...field,
            onChange: handleChange,
          }}
          sx={{ mt: 1 }}
        />
      </Box>
    );
  },
  {
    defaultInitialValue: "",
    validationSchema: yup.string().required("Required field").max(9, "9 numbers maximum").min(9, "9 numbers minimum"),
  },
);

export interface RoutingNumberFieldProps extends Omit<TextFieldProps, "meta" | "form" | "field"> {
  name?: string;
}

export default RoutingNumberField;
